// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"98852dc3","453":"fbafdf8f"}[chunkId] + ".chunk.js";
};